export default "__VITE_ASSET__DIaeFK9q__"